import { all } from "redux-saga/effects";

import userWatcher from "./User";
import propertyWatcher from "./Property";
import surveyWatcher from "./Survey";
import dropDownWatcher from "./DropDown";
import taxCollectoinWatcher from "./TaxCollection";
import changeRequestWatcher from "./ChangeRequest";
import zonesWatcher from "./Zones";
import homePageWatcher from "./HomePage";
import etoWatcher from "./ETO";
import taxInspectorWatcher from "./TaxInspector"
import circlesWatcher from "./Circles"
import tehsilesWatcher from "./Tehsiles"
import mouzasWatcher from './Mouza'
import districtAdminWatcher from "./DistrictAdmin"

export default function* rootWatchers() {
  yield all([
    userWatcher(),
    propertyWatcher(),
    surveyWatcher(),
    dropDownWatcher(),
    taxCollectoinWatcher(),
    changeRequestWatcher(),
    zonesWatcher(),
    homePageWatcher(),
    etoWatcher(),
    taxInspectorWatcher(),
    circlesWatcher(),
    tehsilesWatcher(),
    mouzasWatcher(),
    districtAdminWatcher()
  ]);
}
